import React from 'react';
import styled from 'styled-components';

const HeaderStyles = styled.header`
  width: 100%;
  padding: 12px 2px 8px;
  box-sizing: border-box;
  font-stretch: condensed;

  h1 {
    margin: 0 0 12px;
    color: #172033;
    font-size: clamp(1.7rem, 4vw, 2.3rem);
    font-stretch: normal;
    line-height: 1.15;
  }

  .rating-key {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(min(100%, 220px), 1fr));
    gap: 10px 16px;
    margin: 0;
    padding: 12px 14px;
    border: 1px solid #d8dee8;
    border-radius: 10px;
    background: #f5f7fa;
    list-style: none;
  }

  .rating-key li {
    display: flex;
    min-width: 0;
    align-items: center;
    gap: 9px;
    color: #394458;
    font-size: 0.9rem;
    line-height: 1.25;
  }

  @media (max-width: 600px) {
    padding: 10px 2px 6px;

    .rating-key {
      grid-template-columns: 1fr;
      gap: 8px;
    }
  }
`;

const key = [
  {
    code: 'NS',
    style: 'no-shortage',
    description: 'No shortage; no significant difficulty identified',
  },
  {
    code: 'S',
    style: 'shortage',
    description: 'Shortage; employers have difficulty filling vacancies',
  },
  {
    code: 'M',
    style: 'metropolitan',
    description: 'Shortage limited to metropolitan areas',
  },
  {
    code: 'R',
    style: 'regional',
    description: 'Shortage limited to regional areas',
  },
  {
    code: '—',
    style: 'unknown',
    description: 'Occupation did not exist before ANZSCO 2022',
  },
];

export default function Header() {
  return (
    <HeaderStyles>
      <h1>Occupation Shortage List</h1>
      <ul className="rating-key" aria-label="Rating key">
        {key.map((item) => (
          <li key={item.code}>
            <span className={`rating-code rating-code--${item.style}`}>
              {item.code}
            </span>
            <span>{item.description}</span>
          </li>
        ))}
      </ul>
    </HeaderStyles>
  );
}
